import {getToken} from './auth-persistor';
import NProgress from 'nprogress';
import axios from "axios";

let requestsCounter = 0;

async function Client (endpoint, {method, body, withCredentials=true, ...customConfig} = {}) {
  const token = getToken();

  const isFileUpload = (body && body.files && body.files.length>0);

  const headers = {
    'Content-Type': 'application/json',
  //  'X-Requested-With': 'XMLHttpRequest'
  };

  if (token && withCredentials) {
    headers.Authorization = `Bearer ${token}`;
  }

  method = method || (body ? 'POST' : 'GET');

  const config = {
    baseURL: process.env.REACT_APP_BASE_API_URL,
    url: endpoint,
    method: method,
    headers: {
      ...headers,
      ...customConfig.headers
    }
  };

  if (body) {
    config.data = JSON.stringify(body);
  }

  //we transform request to multipart POST request for laravel backend.
  if (isFileUpload){
    if (body){
      if (!body.hasOwnProperty('files[]')&&body.hasOwnProperty('files')){
        //we change name to be php array compatible.
        body['files[]']=body.files;
        delete body.files;
      }
      config.data = convertToFormData(body);
      if (method.toUpperCase() === 'PUT'){
        config.data.append('_method', 'PUT');
      }
    }
    config.method = 'POST';
    config.headers['Content-Type'] = 'multipart/form-data';
  }

  if (method === 'GET') {
    requestsCounter++;
    NProgress.start();
  }

  const client = axios.create({
    timeout: 120000,
    withCredentials: withCredentials
  });

  return client.request(config)
    .then(r => {
      if (r.status >= 200 && r.status < 300) {
        if ((--requestsCounter) === 0) {
          NProgress.done();
        }
        return r;
      }
      return Promise.reject(r);
    }).catch(error => {
      if (requestsCounter > 0 && ((--requestsCounter) === 0)) {
        NProgress.done();
      }
      return Promise.reject(error);
    });
}

export function convertToFormData(data, formData, parentKey) {
  if(data === null || data === undefined) return null;

  formData = formData || new FormData();

  if (typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
    Object.keys(data).forEach(key =>
      convertToFormData(data[key], formData, (!parentKey ? key : (data[key] instanceof File ? parentKey : `${parentKey}[${key}]`)))
    );
  } else {
    formData.append(parentKey, data);
  }

  return formData;
}

export default Client;
